// @flow
import React, { Component } from "react";
import { BrowserRouter as Router } from "react-router-dom";
// pages
import { Home } from "./views/pages/Home";

import { AuthProvider } from "./AuthenticationStore";
import { PrivateRoute } from "./components/PrivateRoute";

import { Sandbox } from "./components/Sandbox";

export default class App extends Component {
  render() {
    return (
      <AuthProvider>
        {/* demo attribute */}
        {process.env.REACT_APP_SANDBOX? <Sandbox />: null}
        {/* demo attribute */}
        
        <Router basename={`${process.env.REACT_APP_SUB_FOLDER}`}>
          <PrivateRoute component={Home} />
        </Router>
      </AuthProvider>
    );
  }
}
